export type ReviewStatus = "pending" | "approved" | "rejected";

export interface UserReview {
  id: string;
  accommodationId: number;
  accommodationName: string;
  nickname: string;
  rating: number;
  text: string;
  date: string;
  status: ReviewStatus;
  reply?: string;
  createdAt: number;
}

const STORAGE_KEY = "user_reviews";

export const reviewStore = {
  getAll(): UserReview[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as UserReview[]) : [];
    } catch {
      return [];
    }
  },

  getByAccommodation(accommodationId: number): UserReview[] {
    return this.getAll().filter((r) => r.accommodationId === accommodationId);
  },

  getApproved(accommodationId: number): UserReview[] {
    return this.getByAccommodation(accommodationId).filter((r) => r.status === "approved");
  },

  add(review: Omit<UserReview, "id" | "status" | "createdAt">): UserReview {
    const all = this.getAll();
    const newReview: UserReview = {
      ...review,
      id: `rv_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
      status: "pending",
      createdAt: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...all, newReview]));
    return newReview;
  },

  updateStatus(id: string, status: ReviewStatus): void {
    const all = this.getAll().map((r) => (r.id === id ? { ...r, status } : r));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  },

  updateReply(id: string, reply: string): void {
    const all = this.getAll().map((r) => (r.id === id ? { ...r, reply } : r));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  },

  remove(id: string): void {
    const all = this.getAll().filter((r) => r.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  },
};
